import React, { useEffect, useState } from "react";
import EmotiiWelcome from "../../images/emotii-welcome.png";
import PlaceholderLogo from "../../images/logo-placeholder.png";
import useFooter from "../../hooks/useFooter";
import BrandingFooter from "../Footer/BrandingFooter";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import {
  incrementCurrentSlide,
  incrementPeekSlide,
} from "../../store/slices/slides";
import { useDispatch } from "react-redux";

function WelcomeSlide({ isVisible }) {
  const { loginWithRedirect, isAuthenticated, logout } = useAuth0();
  const dispatch = useDispatch();
  useFooter(isVisible, <BrandingFooter />);

  const onLogin = async () => {
    await loginWithRedirect();
  };

  const onLogout = async () => {
    await logout();
  };

  return (
    <div className="h-full bg-emotii-welcome">
      <div className="block-emotti">
        <div className="block-welcome">
          <div className="text-right">
            <div className="logged-user-welcome">
              <img src={EmotiiWelcome} alt="" className="emotii-ttl" />
              <h1 className="">
                Welcome to
                <span className="text-4xl block">
                  {" "}
                  <strong className="font-black">
                    {" "}
                    <i>Emotii</i>
                  </strong>{" "}
                </span>
              </h1>
            </div>

            <i className="mb-3 block">
              How you{" "}
              <strong>
                <u>feel</u>
              </strong>{" "}
              affects{" "}
              <strong>
                <u>everything</u>
              </strong>
            </i>
          </div>

          <p className="text-lg leading-[22px]">
            <i>Emotii</i> helps you better understand your current emotional and
            physical wellbeing.
            <br />
            <br />
            It takes just 1-2 minutes to complete 9 questions, and your results
            will offer guidance on how to improve your wellbeing.
          </p>
          <br />
          <p className="text-sm">
            <strong>Please note:</strong> by using this screening tool, you
            agree to have your results shared with your care team.
          </p>

          <div className="btn-box-introduction">
            <a
              href="#"
              className="btn btn-white"
              onClick={() => {
                dispatch(incrementCurrentSlide());
                dispatch(incrementPeekSlide());
              }}
            >
              Let's get started
            </a>

            {isAuthenticated ? (
              <p className="text-lg p">
                Logged In,{" "}
                <a href="#" className="underline" onClick={onLogout}>
                  log out
                </a>
              </p>
            ) : (
              <p className="text-lg p">
                If returning,{" "}
                <a href="#" className="underline" onClick={onLogin}>
                  login now
                </a>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeSlide;
